import { Badge, type badgeVariants } from './Badge'
import type { VariantProps } from 'class-variance-authority'

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

const STATUS_MAP: Record<string, Record<string, BadgeVariant>> = {
  job: {
    open: 'info',
    in_progress: 'warning',
    waiting_parts: 'warning',
    completed: 'success',
    invoiced: 'primary',
    paid: 'success',
  },
  quote: {
    draft: 'default',
    sent: 'info',
    viewed: 'info',
    approved: 'success',
    declined: 'danger',
    expired: 'default',
    superseded: 'default',
  },
  invoice: {
    draft: 'default',
    sent: 'info',
    paid: 'success',
    overdue: 'danger',
    void: 'default',
  },
  template: {
    active: 'success',
    processing: 'warning',
    error: 'danger',
  },
}

interface StatusBadgeProps {
  entity: keyof typeof STATUS_MAP
  status: string
  className?: string
}

export function StatusBadge({ entity, status, className }: StatusBadgeProps) {
  const variant = STATUS_MAP[entity]?.[status] ?? 'default'
  const label = status.replace(/_/g, ' ')

  return (
    <Badge variant={variant} className={className}>
      <span className="capitalize">{label}</span>
    </Badge>
  )
}
